<template>
  <div id="Booking">
    <div class="row" style="position: initial">
      <div class="col-sm-12 col-md-6 col-lg-4 top" v-if="true">
        <div class="return" @click="$router.push('/')">
          <font-awesome-icon class="icon ml-2" icon="arrow-left" />
        </div>
        <div
          class="language"
          @click="show_all_languages = !show_all_languages"
          v-if="Config.footer.language_selector"
        >
          <div v-if="language == 'en'">
            <img src="/en.png" alt="" />
            <span>English</span>
            <font-awesome-icon class="icon ml-2" icon="caret-up" />
          </div>
          <div v-else-if="language == 'fr'">
            <img src="/fr.png" alt="" />
            <span>Français</span>
            <font-awesome-icon class="icon ml-2" icon="caret-up" />
          </div>
          <div v-else>
            <img src="/tn.png" alt="" />
            <span>العربية</span>
            <font-awesome-icon class="icon ml-2" icon="caret-up" />
          </div>
        </div>
        <div
          class="all_languages"
          v-show="Config.footer.language_selector && show_all_languages"
        >
          <div @click="changeLanguage('en')">
            <img src="/en.png" alt="" />
            <span>English</span>
          </div>
          <div @click="changeLanguage('fr')">
            <img src="/fr.png" alt="" />
            <span>Français</span>
          </div>
          <div @click="changeLanguage('ar')">
            <img src="/tn.png" alt="" />
            <span style="letter-spacing: 0">العربية</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 content" v-if="true">
        <div class="header">
          <div class="logo">
            <img
              v-if="!Config.vendor.custom_ticket_logo"
              src="/btk/btk_logo.png"
              alt=""
            />
          </div>
          <div class="name">
            <a class="date">
              <img src="/check.png" alt="" />
              {{ booking_time }}
            </a>
            <br />
            {{ bookingInfo.business.name }}
            <br />
            <div
              v-for="(item, index) in bookingInfo.services_array"
              :key="index"
              class="badge"
            >
              <a>
                {{ item.title }}
              </a>
            </div>
            <br />
          </div>
        </div>
        <div id="service-bloc-1">
          <div class="services-bloc" v-show="step == 1">
            <div class="services">
              <div class="left">
                <span>{{ $t("Vendor.Validation.SelectService") }}</span>
              </div>
            </div>
            <div class="right">
              <div
                v-for="(service, index) in vendor.services"
                :key="'queueService' + service.id"
              >
                <div style="display: flex; justify-content: space-between">
                  <label :for="'queue_service' + service.id" class="checkbox">
                    {{ service.title }}
                    <input
                      @click="getQuantityServices(index, service.id)"
                      :id="'queue_service' + service.id"
                      name="checkbox-group"
                      type="checkbox"
                    />
                    <span class="checkbox__mark">
                      <svg
                        width="25"
                        height="18"
                        viewBox="0 0 25 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.13449 12.7269L22.2809 0L25 2.64085L9.13449 18L0 9.15702L2.71912 6.51624L9.13449 12.7269Z"
                          fill="#000000"
                        />
                      </svg>
                    </span>
                  </label>
                  <div
                    :class="'plus' + index"
                    style="display: none; margin: auto"
                  >
                    <div
                      v-for="seleted_serv in selected_services"
                      :key="'A' + seleted_serv.id"
                    >
                      <div
                        v-if="seleted_serv.id === service.id"
                        style="display: flex"
                      >
                        <button
                          @click="
                            seleted_serv.quantity > 1
                              ? (seleted_serv.quantity -= 1)
                              : ''
                          "
                          class="buttonQte"
                        >
                          -
                        </button>
                        <div style="font-family: sans-serif">
                          {{ seleted_serv.quantity }}
                        </div>
                        <button
                          @click="
                            seleted_serv.quantity < 9
                              ? (seleted_serv.quantity += 1)
                              : ''
                          "
                          class="buttonQte"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="step == 2">
            <div id="Step2" class="pt-3">
              <div class="section-loader" v-if="loading_dates">
                <img src="/loader-circle.gif" alt="" />
              </div>
              <div v-else>
                <div class="calendar text-center">
                  <div class="text-center mb-1">
                    <label for="member">{{ $t("ChooseDateAndSlots") }}</label>
                  </div>
                  <div style="margin: 10px auto; width: 100%">
                    <datepicker
                      class="datePicker"
                      v-model="selected.date"
                      :format="'yyyy MM dd'"
                      :disabled-dates="datepicker_config.disabled_dates"
                      :monday-first="true"
                      :inline="true"
                      :language="datepicker_config.language"
                      @input="getAvailableSlots()"
                    ></datepicker>
                    <!--
                  <h4 class="week-title">{{selectedDateFormated }}</h4>
                  <vue-horizontal-calendar
                          :highlightedDates="['2022/08/13', '2022/08/14']"
                          @change="getAvailableSlots"
                          @firstDayChange="getDisabledDates"
                          choosedItemColor="var(--primary)"
                          v-model="selected.date"
                          lang="fr"
                          minDate="2022/08/13"
                          :showBorderTop="false"
                  >

                  </vue-horizontal-calendar>
                  --></div>
                  <div class="slots">
                    <div class="section-loader" v-if="loading_slots">
                      <img src="/loader-circle.gif" alt="" />
                    </div>
                    <div v-else>
                      <div
                        v-for="slot in booking_slots"
                        :key="'slots' + slot.slot"
                        class="slot"
                        :class="
                          slot.active == 1
                            ? slot.slot == selected.slot
                              ? 'slot_active slot_selected'
                              : 'slot_active'
                            : 'slot_disabled'
                        "
                        @click="selected.slot = slot.slot"
                        v-show="booking_slots.length"
                      >
                        {{ slot.slot }}
                      </div>
                      <div
                        class="slot slot-danger"
                        v-if="!booking_slots.length"
                      >
                        {{ $t("NoSlotsYet") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="copyright" v-if="Config.ticket.copyright.status">
              <div class="logo">
                <img
                  :src="'/liberrex.png'"
                  alt="Liberrex"
                  :style="
                    'height: ' +
                    Config.ticket.copyright.logo.height +
                    '; width: ' +
                    Config.ticket.copyright.logo.width
                  "
                />
              </div>
              <div class="text">
                <template v-if="$i18n.locale == 'en'">{{
                  Config.ticket.copyright.text.en + $moment().format('YYYY')
                }}</template>
                <template v-else-if="$i18n.locale == 'fr'">{{
                  Config.ticket.copyright.text.fr + $moment().format('YYYY')
                }}</template>
                <template v-else-if="$i18n.locale == 'ar'">{{
                  Config.ticket.copyright.text.ar + $moment().format('YYYY')
                }}</template>
                <template v-else>{{
                  Config.ticket.copyright.text.fr + $moment().format('YYYY')
                }}</template>
              </div>
              <div class="url">
                <a :href="Config.ticket.copyright.link.href">{{
                  Config.ticket.copyright.link.text
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bar col-sm-12 col-md-6 col-lg-4">
      <!-- ---------- buttons step 1 -------- -->
      <div v-if="step === 1">
        <button
          class="button button-filled col-sm-12 col-md-6 col-lg-4"
          @click="
            step = 2;
            specifyBookingDays();
          "
          v-if="selected_services.length"
        >
          {{ $t("Next") }}
        </button>
        <button
          class="button button-filled col-sm-12 col-md-6 col-lg-4"
          v-else
          style="cursor: not-allowed; opacity: 0.7"
        >
          {{ $t("Next") }}
        </button>
      </div>
      <!-- ---------- buttons step 2 -------- -->
      <div v-else>
        <button
          class="button button-filled"
          style="transform: translate(25%, 0)"
          @click="step = 1"
        >
          {{ $t("Return") }}
        </button>
        <button
          class="button button-filled"
          @click="updateAppointment()"
          style="transform: translate(60%, 0)"
          v-if="selected_services.length && selected.slot"
        >
          {{ $t("Confirm") }}
        </button>
        <button
          class="button button-filled"
          v-else
          style="
            cursor: not-allowed;
            opacity: 0.7;
            transform: translate(60%, 0);
          "
        >
          {{ $t("Confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import $ from "jquery";

import { queueService, vendorsService, bookingService } from "../../_services";
import CancelTicket from "../modals/CancelTicket.vue";
import RunningLate from "../modals/RunningLate.vue";
import Datepicker from "vuejs-datepicker";
import { en, ar, fr } from "vuejs-datepicker/dist/locale";

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.prototype.removeDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() - days);
  return date;
};

export default {
  data: () => ({
    windowWidth: window.innerHeight,
    selected: {
      show_dep_and_members: true,

      department: null,
      member: null,
      services: [],
      date: new Date(),
      slot: null,
    },
    holidays: [],
    booking_days: [],
    booking_slots: [],
    loading_dates: false,
    loading_slots: false,
    datepicker_config: {
      today: moment().format("YYYY-MM-DD"),
      language: fr,
      disabled_dates: {
        to: new Date().removeDays(1),
        from: null,
        days: [],
        ranges: [],
      },
    },
    step: 1,
    vendor: {
      services: [],
    },
    selected_services: [],
    servicesGet: [],
    bookingInfo: {
      business: {
        name: "",
        services: [],
      },
    },
    booking_time: null,
    ticket_uid: null,
    ticket: null,
    is_running_late: 0,
    seconds_left: null,
    time_left: "--",
    time_left_interval: null,

    cancel_ticket_modal: {
      active: false,
      type: "danger",
    },
    late_modal: {
      active: false,
      type: "warning",
    },

    position: {
      lat: 36,
      lng: 10,
    },
    position_is_correct: false,
    language: localStorage.getItem("Language"),
    show_all_languages: false,
  }),
  components: {
    Datepicker,
    CancelTicket,
    RunningLate
  },
  methods: {
    reloadCheckboxState() {
      this.selected_services = [];
      this.initPage();
    },
    updateAppointment() {
      $("#PreLoader").show();

      this.bookingInfo.services_array = this.selected_services;
      this.bookingInfo.start_datetime = this.selected.slot;

      let booking = {
        id: this.bookingInfo.id,
        customer_id: this.bookingInfo.customer_id,
        no_slots: this.bookingInfo.no_slots,
        business_id: this.bookingInfo.business_id,
        start_datetime:
          moment(this.selected.date).format("YYYY-MM-DD") +
          " " +
          this.selected.slot,
        end_datetime:
          moment(this.selected.date).format("YYYY-MM-DD") +
          " " +
          this.selected.slot,
        services: this.selected_services,
        additionalData: this.bookingInfo.additionalData,
        queue_target: this.bookingInfo.queue_target,
      };
      bookingService
        .update(booking)
        .then(
          function (data) {
            window.location.href = "/";
          }.bind(this)
        )
        .catch(function () {}.bind(this))
        .finally(
          function () {
            $("#PreLoader").hide();
          }.bind(this)
        );
    },
    getDisabledDates(date) {
      var dateString = moment(date.year + "-" + date.month + "-" + date.date);
      var start = moment(dateString),
        end = moment(dateString.add("days", 7).format("YYYY-MM-DD")),
        day = 0;
      var result = [];
      var current = start.clone();

      while (current.day(7 + day).isBefore(end)) {
        result.push(current.clone().format("YYYY/MM/DD"));
      }
    },
    getAvailableSlots() {
      this.loading_slots = true;
      this.selected.slot = null;

      let data = {
        business_id: this.vendor.id,
        date: moment(this.selected.date).format("YYYY-MM-DD"),
        department: this.bookingInfo.department_id,
        selected_member: this.selected.member ? this.selected.member.id : -1,
        user: this.bookingInfo.user_id,
      };

      this.selected.date = data.date;

      bookingService
        .getAvailabilityUpdate(data, this.booking_id)
        .then(
          function (data) {
            this.booking_slots = data.slots;
            this.loading_slots = false;
          }.bind(this)
        )
        .catch(
          function (ex) {
            this.booking_slots = [];
            this.loading_slots = false;
          }.bind(this)
        )
        .finally(
          function () {
            if (
              this.selected.date ==
              moment(this.bookingInfo.start_datetime).format("YYYY-MM-DD")
            ) {
              this.selected.slot = moment(
                this.bookingInfo.start_datetime
              ).format("HH:mm");
            }
          }.bind(this)
        );
    },
    specifyBookingDays() {
      this.loading_dates = true;
      if (this.selected.member) {
        this.booking_days = this.selected.member.booking_days;
      } else if (this.selected.member) {
        this.booking_days = this.selected.department.booking_days;
      } else {
        this.booking_days = this.vendor.booking_days;
      }

      //Disable non-working days
      this.datepicker_config.days = [];

      this.booking_days.forEach((obj, index) => {
        if (obj.active == 0) {
          this.datepicker_config.disabled_dates.days.push(
            index == 6 ? 0 : index + 1
          );
        }
      });

      //Disable Holidays
      this.datepicker_config.ranges = [];

      this.vendor.holidays.map((obj) => {
        if (
          obj.member_id == null ||
          obj.member == null ||
          (this.selected.member && obj.member_id == this.selected.member.id)
        ) {
          let range = {};
          range["from"] = new Date(obj.start_date);
          range["to"] = new Date(obj.end_date);
          this.datepicker_config.disabled_dates.ranges.push(range);
        }
      });

      //Book J-?
      this.datepicker_config.disabled_dates.from = null;

      if (this.vendor.max_booking_days_before >= 0) {
        let i = 0;
        let searched_day = new Date().getDay();
        let max_booking_days_before = this.vendor.max_booking_days_before;
        while (i < this.vendor.max_booking_days_before) {
          if (this.booking_days[searched_day].active == 0) {
            max_booking_days_before++;
          } else {
            i++;
          }
          searched_day = searched_day == 6 ? 0 : searched_day + 1;
        }
        this.datepicker_config.disabled_dates.from = new Date().addDays(
          max_booking_days_before
        );
      }

      this.loading_dates = false;
      this.getAvailableSlots();
    },
    //fill selected_services from API
    getQuantityServicesAPI(index, service_id, quantity) {
      let obj = {
        index: index,
        id: service_id,
        quantity: quantity,
      };
      this.selected_services.push(obj);

      document.getElementById("queue_service" + service_id).checked = true;
      $(".plus" + index).show();
    },
    getQuantityServices(index, service_id) {
      let obj = {
        index: index,
        id: service_id,
        quantity: 1,
      };
      let indexExists = this.selected_services.findIndex(
        (o) => o.id === obj.id
      );
      if (indexExists === -1) {
        this.selected_services.push(obj);
      } else {
        this.selected_services.splice(indexExists, 1);
      }
      $(".plus" + index).show();
    },
    changeLanguage(language) {
      localStorage.setItem("Language", language);
      this.$router.go();
    },
    ConfirmLateModal() {
      this.late_modal.active = false;
      $("#PreLoader").show();
      let data = {
        queue_line_id: this.ticket.queue_line_id,
        ticket_id: this.ticket.id,
        rank: this.ticket.queue_rank,
      };
      queueService
        .moveToLast(data)
        .then(
          function () {
            this.is_running_late = true;
            this.initPage();
          }.bind(this)
        )
        .catch(function () {
          $("#PreLoader").hide();
        });
    },
    CloseLateModal() {
      this.late_modal.active = false;
    },
    ConfirmCancelTicket() {
      this.cancel_ticket_modal.active = false;
      $("#PreLoader").show();

      queueService
        .revokeTicketByUid(this.ticket_uid)
        .then(
          function () {
            location.replace("/");
          }.bind(this)
        )
        .finally(
          function () {
            $("#PreLoader").hide();
          }.bind(this)
        );
    },
    CloseCancelTicket() {
      this.cancel_ticket_modal.active = false;
    },
    initPage() {
      $("#PreLoader").show();
      this.booking_id = this.$route.params.uid;
      // get services

      bookingService
        .get(this.booking_id)
        .then(
          function (data) {
            this.bookingInfo = data.booking;
            this.servicesGet = data.booking.services_array;
            this.booking_time = moment(this.bookingInfo.start_datetime).format(
              "DD MMM YYYY HH:mm"
            );
            this.selected.date = moment(this.bookingInfo.start_datetime).format(
              "YYYY-MM-DD"
            );

            vendorsService
              .getByShortCode(this.bookingInfo.business.shortcode)
              .then(
                function (data) {
                  this.vendor = data.data;
                  // compare and get selected services (cause get booking return false service_id)
                  for (const service of this.servicesGet) {
                    const found = this.vendor.services.find(
                      (obj) => obj.title === service.title
                    );
                    const index = this.vendor.services.findIndex(
                      (o) => o.id === found.id
                    );
                    // add time to render checkbox
                    setTimeout(() => {
                      this.getQuantityServicesAPI(
                        index,
                        found.id,
                        service.quantity
                      );
                    }, "100");
                  }
                }.bind(this)
              );
          }.bind(this)
        )
        .finally(
          function () {
            setTimeout(() => {
              $("#PreLoader").hide();
            }, "1600");
          }.bind(this)
        );
    },
  },
  computed: {
    selectedDateFormated: function () {
      return moment(this.selected.date).format("MMMM YYYY");
    },
    checkinTimeDateFormated: function () {
      return moment(
        this.ticket.checkinDate + " " + this.ticket.checkinTime
      ).format("HH:mm");
    },
    waitingTimeFormated: function () {
      return moment()
        .startOf("day")
        .add(this.ticket.waiting_time, "seconds")
        .format("HH:mm");
    },
    shouldBeThereAt: function () {
      return moment().add(this.ticket.waiting_time, "seconds").format("HH:mm");
    },
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          this.position.lat = position.coords.latitude;
          this.position.lng = position.coords.longitude;
          this.position_is_correct = true;
        }.bind(this)
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
    var isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
      document.getElementById("service-bloc-1").style.marginBottom = "120px";
    }
    this.initPage();
  },
};
</script>

<style lang="scss">
.circle__value {
  color: var(--primary-font) !important;
}
.vdp-datepicker {
  position: relative;
  .selected {
    background: var(--primary) !important;
    color: var(--primary-font) !important;
  }
}
.vdp-datepicker__calendar {
  margin: 0 auto !important;
}
.vs--searchable .vs__dropdown-toggle {
  height: 40px !important;
}
.day-header,
.day__month_btn,
.month__year_btn {
  font-weight: bold;
  color: var(--primary);
}
.cell:hover {
  border: 1px solid var(--primary) !important;
}
.select {
  z-index: 999;
}
ul {
  z-index: 9999990 !important;
  li {
    z-index: 9999999 !important;
  }
}
.date-highlighted {
  pointer-events: none;
  background: rgba(255, 0, 0, 0.25) !important;
  opacity: 0.6;
  p {
    color: red !important;
  }
}
.week-title {
  border: 2px solid #f2f2f2;
  padding: 5px;
  text-align: center;
  font-size: 16px;
  color: #999999;
  background: #f9f9f9;
  font-weight: 800 !important;
  text-transform: capitalize;
}
</style>
<style lang="scss" scoped>
#Booking {
  // height: 100vh !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  .top {
    top: 0;
    z-index: 1;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 100%;
    text-align: right;
    padding: 10px 30px;
    background: var(--primary);
    border-bottom: 1px solid #dfe4ea93;
    .return {
      float: left;
      color: var(--primary-font);
      margin-top: 0px;
      cursor: pointer;
    }
    .language {
      cursor: pointer;
      float: right;
      img {
        height: 12px;
        width: 20px;
        margin-top: -5px;
        border-radius: 2px;
      }
      .icon {
        color: var(--primary-font);
      }
      span,
      a {
        font-size: 13px;
        padding-left: 10px;
        letter-spacing: 1px;
        color: var(--primary-font);
      }
    }
    .all_languages {
      position: absolute;
      z-index: 9999999999;
      top: 40px;
      right: 10px;
      -webkit-box-shadow: 0 0 1px 1px #ccc;
      box-shadow: 0 0 1px 1px #ccc;
      background: #fff;
      cursor: pointer;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      text-align: left;
      /* float: right; */
      // display: none;
      div {
        padding: 10px 15px;
        img {
          height: 12px;
          width: 20px;
          margin-top: -5px;
          border-radius: 2px;
        }
        span,
        a {
          font-size: 13px;
          padding-left: 10px;
          letter-spacing: 1px;
          color: #333;
        }
      }
      div:hover {
        background: var(--primary);
        span,
        a {
          color: var(--primary-font) !important;
        }
      }
    }
  }
  .loader {
    margin-top: 50%;
    margin-left: 50%;
    transform: translate(-50%, 0);
    img {
      width: 50px;
    }
  }
  .backyard {
    background: #fff;
    border-radius: 0 0 10px 10px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .content {
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 100%;
    height: 93vh;
    background: #fff;
    padding: 20px 20px 20px 20px;
    // overflow-x: hidden !important;
    overflow-y: scroll !important;
    .header {
      display: flex;
      justify-content: center;
      z-index: 999;
      margin-right: 10px;
      background: #ffc10717;
      //background: rgba(red(var(--secondary)), green(var(--secondary)), blue(var(--secondary)), 0.2);
      padding: 10px 25px;
      margin: -20px;
      .logo {
        width: 20%;
        img {
          width: 55px;
          border-radius: 5px;
        }
      }
      .name {
        //width: 45%;
        color: #333;
        font-weight: bold;
        font-size: 12px;
        margin-left: 10px;
        .badge {
          color: var(--primary);
          padding: 5px 5px 5px 0;
          font-size: 12px;
        }
      }
      .booking-delete {
        // background: red; // var(--danger);
        border: 1px solid red;
        display: inline-block;
        text-align: center;
        width: 100%;
        transform: translateY(100%);
        border-radius: 32px;
        color: red;
        font-weight: bold;
        padding: 4px 12px;
        margin: 0 7px 0 16px;
      }
      .date {
        color: var(--secondary);
        font-weight: bold;
        font-size: 14px;
      }
    }

    .services-bloc {
      z-index: 999;
      border-radius: 10px;
      margin-top: 30px;
      padding-bottom: 85px;
      // -webkit-filter: drop-shadow(2px 5px 5px #888);
      // filter: drop-shadow(2px 5px 5px #888);
      // border: 1px solid var(--primary);
      /* box-shadow: 0 4px 2px -2px #c7ccd3; */
      .number {
        padding: 10px 0 0 0;
        text-align: center;
        font-size: 45px;
        font-weight: 900;
        color: var(--primary);
        border-radius: 10px 10px 0 0;
        background: #fff;
      }
      .divider {
        width: 100%;
        z-index: -1;
        margin-top: -15px;
        margin-bottom: -10px;
        .svg {
          width: 100%;
          // padding-right: 0.5px
        }
      }
      .body {
        border-radius: 0 0 10px 10px;
        background: #fff;
        padding: 0 20px 20px 20px;
        line-height: 1.5;
        .info {
          display: flex;
          justify-content: space-evenly;
          text-align: center;
          border-bottom: 2px solid #dfe4ea;
          padding-bottom: 20px;
          .left {
            width: 50%;
            border-right: 2px solid #dfe4ea;
          }
          .right {
            width: 50%;
          }
          span {
            font-size: 17px;
            font-weight: 300;
            display: block;
            color: var(--special-font);
          }
          b {
            font-size: 25px;
            font-weight: 900;
            color: var(--primary);
            font-family: Arial, Helvetica, sans-serif !important;
          }
        }
      }
      .services {
        display: flex;
        justify-content: space-between;
        padding: 10px 0 20px 0;
        .left {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 32px;
          padding: 0px 5px;
          color: var(--special-font);
        }
      }
      .date_join {
        width: 100%;
        text-align: center;
        border-bottom: 2px solid #dfe4ea;
        padding-bottom: 10px;
        small {
          color: var(--special-font);
          font-size: 12px;
        }
        span {
          display: block;
          color: #f7ad36;
        }
      }
      .footer {
        display: flex;
        justify-content: space-around;
        padding-top: 20px;
        .left {
          border-right: 2px solid #dfe4ea;
          width: 50%;
          text-align: center;
          cursor: pointer;
          span {
            color: #f7ad36;
            font-weight: bold;
            display: block;
            font-size: 15px;
          }
        }
        .right {
          width: 50%;
          text-align: center;
          cursor: pointer;
          span {
            color: #e31d1a;
            font-weight: bold;
            display: block;
            font-size: 15px;
          }
        }
      }
    }
    .pub {
    }
    .copyright {
      text-align: center;
      font-size: 15px;
      padding-top: 20px;
      padding-bottom: 50px;
    }
  }
}

.bottom-bar {
  position: fixed;
  bottom: 0px;
  height: 60px;
  width: 100%;
  background: #fff;
  padding: 0 auto;
  left: 33%;
  @media only screen and (max-width: 1024px) {
    left: 25%;
  }
  @media only screen and (max-width: 756px) {
    left: 0;
  }
}

.button {
  border: 3px solid var(--primary);
  border-radius: 100px;
  transform: translate(100%, 0);
  height: 35px;
  transition: 0.3s;
  color: var(--primary);
  background: #fff;
  font-size: 15px;
  width: 35%;
  margin: 13px auto;
  @media only screen and (max-width: 1024px) {
    transform: translate(90%, 0);
  }
  .closedBadge {
    background: var(--danger);
    color: var(--danger-font);
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 10px;
  }
}
.button:hover {
  /* transform: scale(1.02); */
}
.button-filled {
  background: var(--primary);
  color: var(--primary-font);
}

.buttonQte {
  width: 20px;
  height: 22px;
  background-color: var(--secondary);
  border-style: none;
  color: white;
  margin: 0 10px;
  font-size: 16px;
}

// checkbox style
.checkbox {
  font-family: sans-serif;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  justify-content: space-between;
  margin: 6px 0;
  padding: 0 5px;
}
.checkbox input {
  display: none;
}
.checkbox input:checked ~ .checkbox__mark svg {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.checkbox__mark {
  margin-right: 0.5rem;
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid rgb(110, 109, 109);
}
.checkbox__mark svg {
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5);
  width: 80%;
  height: auto;
  transition: all ease 0.2s;
  opacity: 0;
}
.checkbox--disabled {
  color: grey;
  pointer-events: none;
}
.checkbox--disabled .checkbox__mark {
  border-color: grey;
}
.checkbox--disabled .checkbox__mark {
  border-color: grey;
}

.section-loader {
  width: 100%;
  text-align: center;
  img {
    width: 50px;
  }
}

.calendar {
  text-align: left !important;
  label {
    color: var(--primary);
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    margin-top: 20px;
  }
}

.slots {
  margin-bottom: 10px;
  width: 100%;
  div {
    text-align: center;
    .slot {
      display: inline-block;
      background: #fff;
      font-size: 14px;
      border-radius: 20px;
      border: 1px solid var(--special-font);
      color: var(--special-font);
      transition: 0.3s;
      padding: 7px 10px;
      margin: 5px;
      letter-spacing: 1px;
      cursor: pointer;
    }
    .slot:hover {
      transform: scale(1.05);
    }
    .slot_disabled {
      background: #888;
      color: #fff;
      cursor: not-allowed;
      pointer-events: none;
    }
    .slot_selected {
      background: var(--secondary);
      color: var(--secondary-font);
      border: 1px solid var(--secondary);
    }
    .slot-danger {
      background: var(--danger);
      color: var(--danger-font);
      border: 1px solid var(--danger);
      margin: 0 auto;
    }
  }
}
</style>


